export default __webpack_public_path__ + "static/media/thumb_vivek.494805dd.JPG";